import { Options, OptionsState } from './options.types';

export const createEmptyOptions = (): Options => ({
  professionOptions: [],
  domainOptions: [],
  gradeOptions: [],
  technologyOptions: [],
  languageOptions: [],
  languageLevelOptions: [],
  countryOptions: [],
  citiesOptions: [],
  genderOptions: [],
  visaTypesOptions: [],
  currencyOptions: [],
  candidateSourceOptions: [],
  candidateSourceClarificationOptions: [],
  workFormatsOptions: [],
  workloadsOptions: [],
  employmentFormsOptions: [],
  vacancyStatus: [],
  locationOptions: [],
  officeOptions: [],
  statusOptions: [],
  requestFilterStatusOptions: [],
  vacancyPurposeOptions: [],
  statusAuthorsOptions: [],
  jobTitleOptions: [],
  priorityOptions: [],
  overdueOptions: [],
  countriesOptions: [],
  unitOptions: [],
  divisionOptions: [],
  departmentOptions: [],
  certificateOptions: [],
});

export const preloadedOptionsState: OptionsState = {
  options: null,
  loading: false,
  employeesLoading: false,
};
